import { render, staticRenderFns } from "./recorder.vue?vue&type=template&id=191384f4&scoped=true&"
import script from "./recorder.vue?vue&type=script&lang=js&"
export * from "./recorder.vue?vue&type=script&lang=js&"
import style0 from "./recorder.vue?vue&type=style&index=0&id=191384f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191384f4",
  null
  
)

export default component.exports